import React from 'react'
import { Link } from 'react-router-dom'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import BillUpdateModalSF from './BillUpdateModalSF.js'
import PayModalSF from './PayModalSF.js'

const UseOfProceedsUI = ({ context, loan, billList, onRefreshClick,
  onDeleteSubmit, deleteSubmitted, selectedBillId, selectedBill, onDownloadBillClick,
  onUpdateSubmitted, onUpdateSubmitClick, onUpdateCancelClick, onPayClick, payMode, onPayCancel }) =>
  <div>
    {
      billList && billList.length > 0 &&
      <LRTableBodyUI>
        {
          billList.map((bill, i) =>
            <LRTableRowUI key={i} className='g_flex_top'
              context={context}
              left={<RowLeftUI context={context} bill={bill} onDownloadBillClick={onDownloadBillClick} />}
              right={<RowRightUI context={context} bill={bill}
                onDeleteSubmit={onDeleteSubmit}
                deleteSubmitted={deleteSubmitted}
                selectedBillId={selectedBillId}
                onUpdateSubmitted={onUpdateSubmitted}
                onUpdateSubmitClick={onUpdateSubmitClick}
                onUpdateCancelClick={onUpdateCancelClick}
                onPayClick={onPayClick}
              />}
            />
          )
        }
      </LRTableBodyUI>
    }
    <BillUpdateModalSF
      context={context} loan={loan}
      onRefreshClick={onRefreshClick} onCancelClick={onUpdateCancelClick}
      updateMode={onUpdateSubmitted} selectedBillId={selectedBillId} selectedBill={selectedBill}
    />
    {
      selectedBill &&
      <PayModalSF
        context={context} loan={loan}
        onRefreshClick={onRefreshClick} onPayCancel={onPayCancel}
        payMode={payMode} selectedBillId={selectedBillId} selectedBill={selectedBill}
      />
    }
  </div>

const RowLeftUI = ({ bill, onDownloadBillClick }) =>
  <div className='g_flex_v'>
    <span>{bill.billName}</span>
    <span className='g_tiny'>documentRef</span>
    <span>{bill.vendorDocumentRef}</span>
    <span className='g_tiny'>itemSpec</span>
    <span>{bill.itemSpec}</span>
    {
      bill.hasAttachment &&
      <Link className='g_m_top_25' onClick={onDownloadBillClick} to='#' data-id={bill.vendorBillId}>
        Download attachment
      </Link>
    }
    {
      !bill.hasAttachment &&
      <span>No attachment</span>
    }
    <span>Date created: {bill.billDateF1}</span>
    <span>Date paid: {bill.paidDateF1}</span>
    <span>Bill Id: {bill.vendorBillId}</span>
    <span>Due Date: {bill.dueDate}</span>
    <span>Notes: {bill.notes}</span>
    <span>Chart of Account Code: {bill.chartOfAccountCode}</span>

    {/* vendor Details */}
    <div className='g_m_top_50 g_flex_v'>
      <span>Vendor Name: {bill.vendor && bill.vendor.vendorName || "N/A"}</span>
      <span>Beneficiary Name: {bill.vendor && bill.vendor.bankBeneficiaryName || "N/A"}</span>
      <span>Bank IFSC Code: {bill.vendor && bill.vendor.bankIFSCCode || "N/A"}</span>
      <span>Bank Account Number: {bill.vendor && bill.vendor.bankAccountNumber || "N/A"}</span>
    </div>
  </div>

const RowRightUI = ({ context, bill, onDeleteSubmit, deleteSubmitted, selectedBillId, onUpdateSubmitClick, onPayClick }) =>
  <div className='g_flex_h g_flex_top'>
    <table width='180px'><tbody>
      <tr><td>Amount</td><td className='g_text_right'>{bill.subTotalF1}</td></tr>
      {
        bill.taxList.map((tax, j) =>
          <tr key={j}>
            <td className='g_no_wrap_2'>{tax.name}</td>
            <td className='g_text_right'>{tax.amountF1}</td>
          </tr>
        )
      }
      <tr><td>Total</td><td className='g_text_right'>{bill.billAmountF1}</td></tr>
      <tr><td>TDS</td><td className='g_text_right'>{bill.tdsAmountF1}</td></tr>
      <tr><td>Pending</td><td className='g_text_right'>{bill.pendingAmountF1}</td></tr>
    </tbody></table>
    {
      bill.status === 'open' && context.permissions.includes('su_manage') &&
      <div className='g_flex_h g_m_top_25'>
        <SpinnerUI show={deleteSubmitted && selectedBillId == bill.vendorBillId} reserveSpace={true} />
        <span>
          <ButtonTinyUI label='Edit' rowId={bill.vendorBillId} onClick={onUpdateSubmitClick} />
        </span>
        <span className='g_m_left_50'>
          <ButtonTinyUI label='Delete' rowId={bill.vendorBillId} onClick={onDeleteSubmit} />
        </span>
      </div>
    }
    {
      bill.status === 'open' && context.permissions.includes('su_finance') &&
      <div className='g_flex_h g_m_top_25'>
        <span className='g_m_left_50'>
          <ButtonTinyUI label='Pay' rowId={bill.vendorBillId} onClick={onPayClick} />
        </span>
      </div>
    }
    {
      bill.status !== 'open' &&
      <span className='g_m_left_50 g_m_top_25'>
        <BadgeUI label={bill.status} />
      </span>
    }
  </div>

export default UseOfProceedsUI
